import { TextStructure } from './textstructure'

export interface AnswerWebResult {
  // core fields (settable in C#)
  answerstructure?: TextStructure;
  viewstring?: string;
  charcount: boolean;
  // answer?: string;

  // derived/computed getters (likely serialized; mark optional to be safe)
  answersha?: string;
  wordcount?: number;

  entitysimlist?: EntitySim[];

  peoplearray?: number[];
  orgarray?: number[];
  thumbarray?: number[];

  entitysimgroups?: EntitySim[][];
  anyperson?: boolean;
  anyorg?: boolean;

  similarity?: number;
  simint?: number;

  // updatetime is DateTime.Now getter; if serialized it's an ISO string
  updatetime?: string;
}

type EntitySimType = "person" | "org" | "thumb" | string;

interface EntitySim {
  entity?: string;
  entitytype: EntitySimType;
  sim: number;
  // add other backend fields if present
}

// Sentinel "no answer yet" instance. Use to clear a question's answer
// via updateQuestion without casts - every consumer's
// `question.answerobj?.answer` / `?.simint` etc. reads still come back
// undefined, so existing `hasAnswer` / "trace done" checks short-circuit.
export const EMPTY_ANSWER: AnswerWebResult = { charcount: false }
